import { useSnapshot } from 'valtio'
import { environment } from '../environment'

export const useEnvironmentReady = () => {
  const { env } = useSnapshot(environment)

  return env.status === 'ready'
}
